module.exports = __webpack_public_path__ + "static/media/s7.50e459ed.png";